module.exports = __webpack_public_path__ + "static/media/backoffice.e465b063.png";